import AGSSpin from "ags/states/ags-spin";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";

export class CGSpin extends AGSSpin {
    public onEnter() {
        lightningBorderAnimationUtil.enable();
        super.onEnter();
    }
}
